module.exports = __webpack_public_path__ + "img/ic-square-offline.14e67a8b.svg";